import { Plane } from "lucide-react";
import type { INavItem } from "@/models/INavItem";
import { FlightRoutes } from "./routes";
import { FlightPermissions } from "./permissions";

export const flightNav: INavItem = {
  labelKey: "nav.flights",
  icon: Plane,
  path: FlightRoutes.LIST,
  permissions: [FlightPermissions.READ],
};
